// It would be nice to have these in the model files, but in order to run tests that can load settings without the
// svelte files, I am placing these here.

import { settings } from '@dabble/app';
import GenericVirtualizedView from '@dabble/plugins/core/components/GenericVirtualView.svelte';
import { mdiCardTextOutline } from '@mdi/js';
import ProfileView from '../core/components/ProfileView.svelte';
import Book from './components/Book.svelte';
import CastSection from './components/CastSection.svelte';
import Chapter from './components/Chapter.svelte';
import FolderView from './components/Folder.svelte';
import ImagePage from './components/ImagePage.svelte';
import ManuscriptSection from './components/ManuscriptSection.svelte';
import NoteView from './components/Note.svelte';
import NoteImage from './components/NoteImage.svelte';
import Part from './components/Part.svelte';
import PlotGrid from './components/PlotGrid.svelte';
import PlotLine from './components/PlotLine.svelte';
import PlotPoint from './components/PlotPoint.svelte';
import PlotSection from './components/PlotSection.svelte';
import Scene from './components/Scene.svelte';

settings.configure('novel_book', {
  view: {
    component: GenericVirtualizedView,
    searchableFields: ['title', 'subtitle', 'author'],
    ownComponent: Book,
  },
});

settings.configure('novel_part', {
  view: {
    component: GenericVirtualizedView,
    searchableFields: ['title'],
    ownComponent: Part,
  },
});

settings.configure('novel_chapter', {
  view: {
    component: Chapter,
    searchableFields: { novel_chapter: ['title'], novel_scene: ['body'] },
  },
});

settings.configure('novel_scene', {
  view: {
    component: Scene,
    searchableFields: ['body'],
  },
});

settings.configure('novel_folder', {
  view: {
    component: FolderView,
    searchableFields: ['title'],
  },
});

settings.configure('novel_page', {
  view: {
    component: NoteView,
  },
});

settings.configure('novel_plot_point', { view: { component: PlotPoint } });
settings.configure('novel_book_scenes', { view: { component: PlotLine } });

settings.configure('novel_plot', {
  view: {
    component: PlotGrid,
  },
});

settings.configure('novel_plot_line', {
  view: {
    component: PlotLine,
  },
});

settings.configure('novel_plot_point', {
  icon: mdiCardTextOutline,
  view: {
    component: PlotPoint,
  },
});

settings.configure('novel_book_scenes', {
  view: {
    component: PlotLine,
  },
});

settings.configure('novel_manuscript', {
  view: {
    component: ManuscriptSection,
  },
});

settings.configure('novel_plots', {
  view: {
    component: PlotSection,
  },
});

settings.configure('novel_notes', {
  view: {
    component: FolderView,
    searchableFields: [],
  },
});

settings.configure('novel_image', {
  view: {
    component: ImagePage,
  },
});

settings.configure('note_image', {
  view: {
    component: NoteImage,
  },
});

settings.configure('novel_characters', {
  view: {
    component: FolderView,
    searchableFields: ['title'],
  },
});

settings.configure('novel_cast', {
  view: {
    component: CastSection,
  },
});

settings.configure('novel_character', {
  view: {
    component: ProfileView,
    searchableFields: ['title'],
  },
});
